export default __webpack_public_path__ + "static/media/ic_barcode_scanned.84655e69.svg";